import { Field, RawInput as Input } from '@payaca/ambrosia';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { z } from 'zod/v4';

export const LINE_ITEM_REFERENCE_FORM_SCHEMA = z.object({
  reference: z.string(),
});

export type TLineItemReferenceFormState = z.infer<
  typeof LINE_ITEM_REFERENCE_FORM_SCHEMA
>;

type TProps = {
  className?: string;
};

const ReferenceField: FC<TProps> = (props) => {
  const { className } = props;

  const formMethods = useFormContext<TLineItemReferenceFormState>();

  return (
    <Field.Legacy
      className={className}
      validationState={
        formMethods.formState.errors.reference
          ? {
              isValid: false,
              validationMessages: ['Reference is required'],
            }
          : undefined
      }
    >
      <Field.Label>Internal reference</Field.Label>

      <Input {...formMethods.register('reference')} />
    </Field.Legacy>
  );
};

export default ReferenceField;
